import React, { useState } from 'react';
import { Button } from '../../../../common/components';
import './styles.scss';

import CommissionSlider from '../CommissionSlider';
import { Col, Row } from 'react-bootstrap';

const PremiumAdjustSliders = ({
  input,
  isCalculating,
  handleCommissionAdjustments,
  initialCommissions,
  currentCommissions,
}) => {
  const [commissions, setCommissions] = useState(currentCommissions);

  if (!commissions || !Object.keys(commissions).length) {
    return null;
  }

  const handleAdjustment = () => {
    Promise.resolve(
      input.onChange({
        ...commissions,
      }),
    ).then(() => {
      handleCommissionAdjustments();
    });
  };

  const handleChange = (rate, type) => {
    setCommissions({
      ...commissions,
      [type]: rate,
    });
  };

  return (
    <div className="commission-adjust">
      <h4>Commission Adjustment</h4>
      <Row>
        <Col sm={12}>
          <div className="slider-horizontal">
            <p className="text-center">
              Just Travel {`${commissions?.commission_owner?.toFixed(2)}%`}
            </p>
            <div className="slider-box">
              <CommissionSlider
                handleChange={handleChange}
                isCalculating={isCalculating}
                step={0.5}
                max={parseFloat(initialCommissions.commission_owner)}
                initialValue={commissions.commission_owner}
                rate={commissions.commission_owner}
                type={'commission_owner'}
              />
            </div>
          </div>
          {commissions.commission_broker && commissions.commission_broker > 0 && (
            <div className="slider-horizontal">
              <p className="text-center">
                Broker {`${commissions.commission_broker.toFixed(2)}%`}
              </p>
              <div className="slider-box">
                <CommissionSlider
                  handleChange={handleChange}
                  isCalculating={isCalculating}
                  step={0.5}
                  max={parseFloat(initialCommissions.commission_broker)}
                  initialValue={commissions.commission_broker}
                  rate={commissions.commission_broker}
                  type={'commission_broker'}
                />
              </div>
            </div>
          )}
          <div className="slider-box">
            <Button
              label="Calculate Premium"
              handleClick={handleAdjustment}
              bsStyle="primary"
              className="btn-calculate-premiums"
              block
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PremiumAdjustSliders;
